import { QueryParamsType } from "src/types/query-params";
import qs from "qs";
import useRequest from "src/hooks/useRequest";

export const usePaymentlog = (query: Record<string, QueryParamsType>) => {
  const url = `/payment-logs?${qs.stringify(query)}`;
  const { data, mutate, isLoading, error, ...rest } = useRequest(url, url);

  return {
    paymentLogs: (data as any) || [],
    mutate,
    isLoading: isLoading,
    error: error,
    ...rest,
  };
};
